/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { CarBookingList as CarBookingListMole } from "../../molecules";
import { CarBookingWrapper } from "./CarBooking.style";
import { CarBookingListToolbar } from "./CarBookingListToolbar";

export const CarBookingList: React.FC = () => {
  const { bookingCars } = useSelector((state: any) => state.bookings);
  const { loading } = useSelector((state: any) => state.async);
  const [searchBookingId, setSearchBookingId] = React.useState("");
  const filteredBookings = React.useMemo(() => {
    const query = searchBookingId.trim().toLowerCase();
    if (!query) return bookingCars;
    return bookingCars.filter((booking: any) =>
      String(booking.bookingId || "")
        .toLowerCase()
        .includes(query)
    );
  }, [bookingCars, searchBookingId]);
  return (
    <AdminPageBody
      pageToolbar={
        <CarBookingListToolbar
          searchBookingId={searchBookingId}
          onSearchBookingIdChange={setSearchBookingId}
        />
      }
    >
      <CarBookingWrapper>
        <CarBookingListMole bookings={filteredBookings} loading={loading} />
      </CarBookingWrapper>
    </AdminPageBody>
  );
};
